import numeral from 'numeral';
import { formatMoney } from './stringUtils.js';

const formatRewardAmount = (rewardAmount, includeDecimal = false) => {
    if ((rewardAmount === null || rewardAmount === void 0 ? void 0 : rewardAmount.rewardAmountType) === 'percent') {
        return numeral((rewardAmount === null || rewardAmount === void 0 ? void 0 : rewardAmount.rewardPercent) / 100.0).format(`0,0%`);
    }
    return formatMoney(rewardAmount === null || rewardAmount === void 0 ? void 0 : rewardAmount.rewardAmount, '$', includeDecimal);
};
const getBrandIds = (brandEntity) => {
    if ((brandEntity === null || brandEntity === void 0 ? void 0 : brandEntity.brandIds) && Array.isArray(brandEntity.brandIds) && brandEntity.brandIds.length > 0) {
        return brandEntity.brandIds;
    }
    if ((brandEntity === null || brandEntity === void 0 ? void 0 : brandEntity.brandId) != null) {
        return [brandEntity.brandId];
    }
    return undefined;
};

export { formatRewardAmount, getBrandIds };
//# sourceMappingURL=brandUtils.js.map
